import api from './api'
import axios from 'axios'

// Base URL for CSRF cookie. Always use the current origin to ensure
// proper cookie domain handling between www and non-www subdomains
const baseURL = ''

export const authService = {
  // Get CSRF cookie before login/register
  getCsrfCookie: async () => {
    // CSRF cookie endpoint is NOT under /api - use axios directly with full URL
    const csrfUrl = `/sanctum/csrf-cookie`;
    
    try {
      // Use axios directly to avoid /api prefix for CSRF endpoint
      const response = await axios.get(csrfUrl, { withCredentials: true });
      
      // Small delay to ensure cookie is set
      await new Promise(resolve => setTimeout(resolve, 100));
      
      return response;
    } catch (error) {
      console.error('❌ CSRF cookie error:', error.response?.status, error.response?.data);
      throw error;
    }
  },

  // Login user
  login: async (email, password) => {
    // Get CSRF token first
    try {
      await authService.getCsrfCookie()
      
      const response = await api.post('/auth/login', { email, password })
      return response.data
    } catch (error) {
      console.error('❌ Login error details:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        fullError: error
      });
      throw error;
    }
  },

  // Register new user
  register: async (name, email, password, password_confirmation) => {
    // Get CSRF token first
    await authService.getCsrfCookie()
    const response = await api.post('/auth/register', {
      name,
      email,
      password,
      password_confirmation,
    })
    return response.data
  },

  // Logout user
  logout: async () => {
    const response = await api.post('/auth/logout')
    return response.data
  },

  // Get current user
  getUser: async () => {
    const response = await api.get('/auth/me')
    return response.data
  },
}
